import { useAtomValue, useSetAtom } from 'jotai';
import { userConfigsAtom } from '@/atoms/queries/userConfigs';
import { toastDataAtom } from '@/atoms/toast';
import { userConfigIdAtom, userConfigNameAtom } from '@/atoms/userConfigs';
import { UserConfigType } from '@/types/userConfigs';
import { useUpsertUserConfig } from './useUpsertUserConfig';

export const useRenameConfig = () => {
  const upsertUserConfig = useUpsertUserConfig();
  const userConfigs = useAtomValue(userConfigsAtom);
  const setToastData = useSetAtom(toastDataAtom);
  const configIdToAmend = useAtomValue(userConfigIdAtom);
  const configToRename = userConfigs.data.find(config => config.configId === configIdToAmend);
  const newUserConfigName = useAtomValue(userConfigNameAtom);

  const renameConfig = async () => {
    if (!configToRename || !configIdToAmend || !newUserConfigName) {
      setToastData({ toastName: 'renameConfig', type: 'error', entityName: newUserConfigName || '' });
      return { isSuccess: false };
    }

    const configDefinition = {
      ...configToRename.definition,
      titleSettings: {
        title: newUserConfigName,
        translate: false,
      },
    };

    const { isSuccess } = await upsertUserConfig({
      configId: configIdToAmend,
      configType: configToRename.type as UserConfigType,
      configDefinition,
    });

    setToastData({ toastName: 'renameConfig', type: isSuccess ? 'success' : 'error', entityName: newUserConfigName });
    return { isSuccess };
  };

  return renameConfig;
};
